export default __webpack_public_path__ + "static/media/software.99fde2b2.jpg";